<template>
  <div class="tc_userRegistration">
    <div class="userReg-layout">
      <!-- 注册 -->
      <div class="userReg" v-if="isReg">
        <div class="userReg-header">
          <p>注册账号</p>
        </div>
        <div class="content">
          <!-- 头像 -->
          <div class="headImg">
            <el-upload
              class="avatar-uploader"
              action="/upload_api"
              :show-file-list="false"
              :on-success="fileUploadApi"
              :data="fileData"
              :before-upload="beforeAvatarUpload"
            >
              <!-- :before-upload="beforeAvatarUpload" -->
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <!-- 个人信息 -->
          <div class="info">
            <el-form
              ref="form"
              :model="form"
              :rules="rules"
              label-width="120px"
              size="mini"
              status-icon
            >
              <el-form-item
                label="住院号/登记号:"
                prop="account"
                
              >
                <el-input
                  v-model="form.account"
                  maxlength="14"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="用户姓名:" prop="name">
                <el-input
                  v-model="form.name"
                  maxlength="12"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="密码:" prop="password" >
                <el-input
                  type="password"
                  v-model="form.password"
                  maxlength="16"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="确认密码:" prop="affpassword" >
                <el-input
                  type="password"
                  v-model="form.affpassword"
                  maxlength="16"
                  show-word-limit
                ></el-input>
                <el-row type="flex" justify="end">
                  <span class="showPaww" @click="showPaww" v-if="isshowPassword"
                    >显示密码</span
                  >
                  <span
                    class="showPaww"
                    @click="showPaww"
                    v-if="!isshowPassword"
                    >隐藏密码</span
                  >
                </el-row>
              </el-form-item>
              <el-form-item label="性别:" prop="sex">
                <el-radio-group v-model="form.sex">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="0">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="年龄:" prop="age">
                <el-input-number
                  v-model="form.age"
                  :min="0"
                  :max="150"
                  :precision="0"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="文化程度:" prop="culture">
                <el-select v-model="form.culture">
                  <el-option label="文盲" value="文盲"></el-option>
                  <el-option label="小学" value="小学"></el-option>
                  <el-option label="初中" value="初中"></el-option>
                  <el-option label="高中/中专/技校" value="高中/中专/技校"></el-option>
                  <el-option label="大学专科" value="大学专科"></el-option>
                  <el-option label="大学本科" value="大学本科"></el-option>
                  <el-option label="硕士" value="硕士"></el-option>
                  <el-option label="博士及以上" value="博士及以上"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="部门:" prop="department_id">
                <el-select v-model="form.department_id">
                  <el-option
                    :label="item.name"
                    :value="item.id"
                    v-for="item in departmentList"
                    :key="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="学校:" prop="school">
                <el-input
                  v-model.trim="form.school"
                  maxlength="20"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="年级:" prop="nianji">
                <el-select v-model="form.nianji">
                  <el-option
                    v-show="form.culture == '小学'"
                    label="一"
                    value="一"
                  ></el-option>
                  <el-option
                    v-show="form.culture == '小学'"
                    label="二"
                    value="二"
                  ></el-option>
                  <el-option
                    v-show="form.culture == '小学'"
                    label="三"
                    value="三"
                  ></el-option>
                  <el-option
                    v-show="form.culture == '小学'"
                    label="四"
                    value="四"
                  ></el-option>
                  <el-option
                    v-show="form.culture == '小学'"
                    label="五"
                    value="五"
                  ></el-option>
                  <el-option
                    v-show="form.culture == '小学'"
                    label="六"
                    value="六"
                  ></el-option>
                  <el-option
                    v-show="form.culture == '初中'"
                    label="七"
                    value="七"
                  ></el-option>
                  <el-option
                    v-show="form.culture == '初中'"
                    label="八"
                    value="八"
                  ></el-option>
                  <el-option
                    v-show="form.culture == '初中'"
                    label="九"
                    value="九"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="班级:" prop="banji">
                <el-select v-model="form.banji">
                  <el-option
                    v-for="(item, index) in 20"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item> -->
               <!--<el-form-item label="联系电话:" prop="phone">
                <el-input
                  v-model.trim="form.phone"
                  maxlength="11"
                  show-word-limit
                ></el-input>
              </el-form-item>-->

              <!-- 绑定信息 -->
              <el-collapse v-model="activeNames">
                <el-collapse-item title="选填信息" name="1">
                  <!-- 自填信息 -->
                  <template v-for="item in archivesData">
                    <!-- 单行文本 -->
                    <template v-if="item.type === 1">
                      <el-form-item :label="item.name + ':'" :key="item.id">
                        <el-input v-model="form.archives[item.key]"></el-input>
                      </el-form-item>
                    </template>
                    <!-- 下拉框 -->
                    <template v-if="item.type === 3">
                      <el-form-item :label="item.name + ':'" :key="item.id">
                        <el-select v-model="form.archives[item.key]">
                          <el-option
                            :label="item2"
                            :value="item2"
                            v-for="(item2, key) in item.content"
                            :key="key"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                    <!-- 单选 -->
                    <template v-if="item.type === 4">
                      <el-form-item :label="item.name + ':'" :key="item.id">
                        <el-radio-group v-model="form.archives[item.key]">
                          <el-radio
                            :label="item2"
                            v-for="(item2, key) in item.content"
                            :key="key"
                          ></el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </template>
                    <!-- 复选 -->
                    <template v-if="item.type === 5">
                      <el-form-item :label="item.name + ':'" :key="item.id">
                        <el-checkbox-group v-model="form.archives[item.key]">
                          <el-checkbox
                            :label="item2"
                            v-for="(item2, key) in item.content"
                            :key="key"
                          ></el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </template>
                    <!-- 文本域 -->
                    <template v-if="item.type === 2">
                      <el-form-item :label="item.name + ':'" :key="item.id">
                        <el-input
                          type="textarea"
                          v-model="form.archives[item.key]"
                          :rows="5"
                        ></el-input>
                      </el-form-item>
                    </template>
                  </template>
                </el-collapse-item>
              </el-collapse>
              <!-- 按钮 -->
              <el-row type="flex" justify="center" class="btn">
                <el-button type="success" @click="gologin"
                  >已有帐号,返回登录</el-button
                >
                <el-button type="primary" @click="createdUser"
                  >立即创建</el-button
                >
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
      <!-- 注册成功 -->
      <transition name="el-fade-in-linear">
        <div class="regSuccess" v-if="!isReg">
          <div class="title">
            <i class="el-icon-check"></i>恭喜你! <i></i>注册成功
          </div>
          <div class="msg">
            <span @click="goHome">开始答题</span>
            <!-- <span @click="gologin">返回登陆页面</span> -->
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { login } from "@/api/login.js";
import { getuserinfo } from "@/api/answer.js";
import {
  getbywhere,
  getUserDepartment,
  register,
  getUserAccount,
} from "@/api/comm.js";
import { exists } from "fs";
import moment from "moment";
// import { async } from "q";
let status = 0;
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.affpassword !== "") {
          this.$refs.form.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        this.ispassword = false;
        callback(new Error("两次输入密码不一致!"));
      } else {
        this.ispassword = true;
        callback();
      }
    };
    var validateAcc = (rule, value, callback) => {
      if (rule) {
        getbywhere({ account: this.form.account }).then((res) => {
          if (res.msg) {
            callback(new Error("对不起，用户账户已存在"));
          } else {
            callback();
          }
        });
      } else {
        callback();
      }
    };

    return {
      rules: {
        password: [
          {
            required: true,
            min: 4,
            max: 16,
            message: "长度在 4 到 16 个字符",
            trigger: "blur",
          },
          { validator: validatePass, trigger: "change" },
        ],
        affpassword: [
          { required: true, validator: validatePass2, trigger: "change" },
        ],
        account: [
          {
            required: true,
            min: 4,
            max: 12,
            message: "长度在 4 到 12 个字符",
            trigger: "blur",
          },
          { validator: validateAcc, trigger: ["blur", "change"] },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        culture: [
          { required: true, message: "请选择文化程度", trigger: "change" },
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]+$/,
            message: "请输入正确的姓名",
            trigger: "blur",
          },
        ],
        age: [{ required: true, message: "请填写年龄", trigger: "blur" }],
        department_id: [
          { required: true, message: "请选择部门", trigger: "change" },
        ],
        school: [
          { required: true, message: "请输入学校名称", trigger: "change" },
        ],
        nianji: [{ required: true, message: "请选择年级", trigger: "change" }],
        banji: [{ required: true, message: "请选择班级", trigger: "change" }],
        phone: [
          { required: true, message: "请输入电话号码", trigger: "change" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            min: 11,
            max: 11,
            message: "电话号码格式不正确",
            trigger: "blur",
          },
        ],
      },
      form: {
        type: 1,
        account: "",
        sex: 1,
        name: "",
        password: "",
        affpassword: "",
        culture: "",
        head_id: "",
        age: "",
        department_id: "",
        begin_time: 0,
        end_time: 0,
        archives: {
          banji: "",
          nianji: "",
          school: "",
        },
        phone: "",
      },
      archivesData: [],
      status: 0,
      activeNames: ["1"],
      fileData: {
        type: 0,
        attribution_id: 1, // 当前 用户的id
      },
      imageUrl: "./static/img/regtx.png",
      departmentList: [],
      // 控制注册成功状态
      isReg: true,
      ispassword: false,
      isshowPassword: true,
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //只能选择今天及今天之前
        },
      },
    };
  },
  created() {
    // ***判断是否是扫描二维码后的用户***
    if (this.$route.query.meaids) {
      localStorage.setItem("ByQr", JSON.stringify(this.$route.query)); // 存储通过二维码扫描的标示
    }
    if (localStorage.getItem("ByQr")) {
      let byQr = JSON.parse(localStorage.getItem("ByQr"));
      // ***判断传递的参数中是否存在部门参数***
      if (byQr.depName != "" && byQr.depId != "") {
        let dep = {
          id: byQr.depId * 1,
          name: byQr.depName,
        };
        // ***如果是，则渲染传递过来的部门数据***
        this.departmentList.push(dep);
        this.form.department_id = dep.id;
      } else {
        // ***如果不是，则对部门下拉框进行加载***
        this.loadDep();
      }
    } else {
      // ***如果不是，则对部门下拉框进行加载***
      this.loadDep();
    }
  },
  mounted() {
    // 自动填写密码账号
    getUserAccount().then((res) => {
      if (res.code == 400200) {
        this.form.password = res.data.password + "";
        this.form.affpassword = res.data.password + "";
        this.archivesData = res.archives;
        this.form.account = res.data.account + "";
      }
    });
  },
  methods: {
    // 验证用户名是否重复
    verifyAcc() {
      let a = false;
      getbywhere({ account: this.form.account }).then((res) => {});
    },
    // 文件上传成功的狗子
    fileUploadApi(response, file) {
      this.form.head_id = response.data.id;
      this.form.p;
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    // 图片上次校验
    beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "jpg" ||
        testmsg === "jpeg" ||
        testmsg === "JPG" ||
        testmsg === "png" ||
        testmsg === "PNG" ||
        testmsg === "bpm" ||
        testmsg === "BPM";
      const isLt50M = file.size / 1024 / 1024 < 2;
      if (!extension) {
        this.$message({
          message: "上传图片只能是jpg / png / bpm格式!",
          type: "error",
        });
        return false;
      }
      //console.log(file);
      if (!isLt50M) {
        this.$message({
          message: "上传文件大小不能超过 2MB!",
          type: "error",
        });
        return false;
      }
      return extension || isLt50M;
    },
    // 提交创建
    createdUser() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.form.end_time =
            Date.parse(new Date()) / 1000 + 30 * 60 * 60 * 24;
          // 年龄转出生日期
          let cuTime = moment().format("YYYY");

          let { school, nianji, banji, phone } = this.form;
          this.form.archives.school = school;
          this.form.archives.nianji = nianji;
          this.form.archives.banji = banji;
          this.form.archives.phone = phone;
          // this.form.account = phone;

          let data = JSON.parse(JSON.stringify(this.form));
          let newAge = cuTime - data.age;
          data.age = `${newAge}-01-01`;
          // 创建用户 后 自动登录
          register(data).then((res) => {
            if (res.code == 400200) {
              this.isReg = false;
              const { account } = res.data;
              // console.log("后台获取",account);
              // localStorage.removeItem("ByQr");
              let param = {
                userName: account,
                password: this.form.password,
                type: 1,
              };
              // 自动登录
              login(param).then((res) => {
                console.log(res);
                if (res.code === 400200) {
                  // ---------获取用户ID------------------
                  getuserinfo().then((res) => {
                    if (res.code == 400200) {
                      this.userInfo = res.data;
                      localStorage.setItem("user_id", this.userInfo.id);
                      localStorage.setItem(
                        "userInfo",
                        JSON.stringify(this.userInfo)
                      ); // 2022年10月31日 唐加宇
                    }
                  });
                }
              });
            }
          });
        } else {
          this.$message({
            message: "请检查带 * 的内容！",
            type: "warning",
          });
          return false;
        }
      });
    },
    // 前往答题页面
    goHome() {
      localStorage.setItem("token", "admintoken");
      this.$router.push("/answer_content/answer_list");
    },
    gologin() {
      localStorage.setItem("isReg", 2);
      
      if(this.$route.query.depId){
        this.$router.push({
          path: '/userLogin',
          query: this.$route.query
        })
      }else {
        this.$router.push("/userLogin");
      }
    },

    // 显示密码
    showPaww() {
      let arr = document.querySelectorAll("input");
      if (this.isshowPassword) {
        arr[3].type = "text";
        arr[4].type = "text";
        this.isshowPassword = false;
      } else {
        arr[3].type = "password";
        arr[4].type = "password";
        this.isshowPassword = true;
      }
    },
    // 加载部门
    loadDep() {
      getUserDepartment().then((res) => {
        if (res.code === 400200) {
          this.departmentList = res.data.data;
        }
      });
    },
  },
};
</script>

<style lang="less">
.tc_userRegistration {
  width: 100%;
  zoom: 1;
  box-sizing: border-box;
  height: 100%;

  .userReg-layout {
    max-width: 768px;
    min-width: 325px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .userReg-header {
    // height: 50px;
    flex: 1;
    text-align: center;
    background: rgb(217, 237, 238);

    p {
      font-size: 25px;
      color: rgb(37, 37, 37);
      line-height: 50px;
      font-weight: 700;
      text-shadow: #ffffff 2px 2px;
    }
  }

  .content {
    box-shadow: black 0px 2px 15px;
    // height: calc~ "(100% - 50px)";
    flex: 13;
    // height: 100%;
    // 头像
    background: white;

    .headImg {
      padding-top: 10px;
      display: flex;
      justify-content: center;
      border-radius: 50%;

      .avatar-uploader .el-upload {
        border: 1px solid rgb(38, 103, 114);
        border-radius: 50px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }

      .avatar-uploader .el-upload:hover {
        border-color: #409eff;
      }

      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
      }

      .avatar {
        width: 80px;
        height: 80px;
        display: block;
      }
    }

    .info {
      padding: 0px 20px;
      padding-top: 20px;

      .btn {
        margin-top: 20px;
      }

      // 抽屉
      .el-collapse {
        .el-collapse-item__header {
          border-top: 1px rgb(38, 103, 114) solid;
          background: transparent;
        }

        .el-collapse-item__wrap {
          background: transparent;
        }
      }
    }
  }

  .regSuccess {
    background: rgb(203, 237, 240);
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .title {
      font-weight: 700;
      font-size: 30px;
      color: green;
    }

    .msg {
      margin: 60px;
      display: flex;
      justify-content: space-between;

      span {
        margin: 0 20px;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;
      }
    }
  }

  .showPaww {
    color: rgb(110, 110, 110);
    cursor: pointer;
  }
}
</style>